import { AppLinkKey } from '@app/config/appLink'
import { guideContentTypes } from '../config/guide.config'

export const guideContentTypeLinkMap: Partial<
  Record<(typeof guideContentTypes)[number], AppLinkKey>
> = {
  fundamentals: 'guideFundamentals',
  methods: 'guideMethods',
  insights: 'guideInsights',
  tutorials: 'guideTutorials',
  demos: 'guideDemos',
  glossary: 'guideGlossary',
}

export type TopicLandingContentType = 'article' | 'tutorial' | 'demo'

export type TopicLandingItem = {
  id?: number
  documentId?: string
  title?: string
  slug?: string
  Slug?: string
  description?: string | null
  subTabTitle?: string | null
  subTabSlug?: string | null
  contentType: TopicLandingContentType
}

export const ARTICLES_PER_PAGE = 6

export const contentTypeLabels: Record<TopicLandingContentType, string> = {
  article: 'View article',
  tutorial: 'View tutorial',
  demo: 'View demo',
}

export const formatTopicTitle = (topic?: string) => {
  if (!topic) return 'Guide topic'

  return topic
    .split('-')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

export const getTopicLandingItemTitle = (item: {
  title?: string
  attributes?: { title?: string }
}) => {
  return item.title ?? item.attributes?.title ?? 'Untitled item'
}

export const getTopicLandingItemHref = (item: TopicLandingItem) => {
  const slug = item.slug ?? item.Slug ?? '#'
  return item.subTabSlug ? `${item.subTabSlug}/${slug}` : slug
}
